import { useState, type MouseEvent } from "react";
import { ArrowUpToLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/use-toast";
import { putFetcher } from "api/swr";

export function PinDefaultSetButton({
  avatarId,
  onPinned,
}: {
  avatarId: string;
  onPinned: () => void | Promise<void>;
}) {
  const [pending, setPending] = useState(false);

  const handlePin = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (pending) return;
    setPending(true);
    try {
      await putFetcher(`/spine-avatars/${avatarId}/pin`, { arg: {} });
      toast({
        title: "已置顶",
        description: avatarId,
        className: "bg-green-500 text-white",
      });
      await onPinned();
    } catch (err) {
      toast({
        variant: "destructive",
        title: "置顶失败",
        description: err instanceof Error ? err.message : "未知错误",
      });
    } finally {
      setPending(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="h-7 w-7 shrink-0"
      onClick={handlePin}
      disabled={pending}
      title="置顶"
    >
      <ArrowUpToLine className="h-3.5 w-3.5" />
    </Button>
  );
}
